import React, { useEffect, useState } from 'react';
import { Select, MenuItem, Typography, Box } from '@mui/material';
import axios from 'axios';
import { API_BASE } from '../config';

const MACHINE_API = `${API_BASE}/zts/admin/v1.0/machine/location/`;

const MachineSelectDropdown = ({ selectedMachine, setSelectedMachine, setLocationName }) => {
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    const fetchMachines = async () => {
      try {
        const res = await axios.get(MACHINE_API);
        setMachines(res.data);
      } catch (err) {
        console.error('Failed to fetch machines:', err);
      }
    };
    fetchMachines();
  }, []);

  const handleChange = (e) => {
    const selectedUid = e.target.value;
    const selected = machines.find(m => m.uid === selectedUid);
    setSelectedMachine(selectedUid);
    setLocationName(selected?.location || '');
  };

  return (
    <Box>
      <Select
        fullWidth
        value={selectedMachine}
        onChange={handleChange}
        displayEmpty
        sx={{ mb: 2 }}
      >
        <MenuItem value=""><em>Select Machine</em></MenuItem>
        {machines.map(m => (
          <MenuItem key={m.uid} value={m.uid}>{m.serial}</MenuItem>
        ))}
      </Select>
      {selectedMachine && (
        <Typography sx={{ mb: 2 }}>
          <strong>Location:</strong> {machines.find(m => m.uid === selectedMachine)?.location || '-'}
        </Typography>
      )}
    </Box>
  );
};

export default MachineSelectDropdown;
